export enum TypeBetweenMealsEnum {
  NO = 'I DONT EAT ANYTHING BETWEEN MEALS',
  SWEET = 'SWEET',
  SALTY = 'SALTY'
}
